function cov_2ea1khrmtd() {
  var path = "/app/src/components/logo/components/logo-en-black-on-green/index.ts";
  var hash = "ffc396b74e490295c0ccbf2e23f230c836d67da9";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/logo/components/logo-en-black-on-green/index.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ffc396b74e490295c0ccbf2e23f230c836d67da9"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2ea1khrmtd = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2ea1khrmtd();
export { LogoEnBlackOnGreen } from './logo-en-black-on-green';